var __create = Object.create;
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __markAsModule = (target) => __defProp(target, "__esModule", { value: true });
var __export = (target, all) => {
  __markAsModule(target);
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __reExport = (target, module2, desc) => {
  if (module2 && typeof module2 === "object" || typeof module2 === "function") {
    for (let key of __getOwnPropNames(module2))
      if (!__hasOwnProp.call(target, key) && key !== "default")
        __defProp(target, key, { get: () => module2[key], enumerable: !(desc = __getOwnPropDesc(module2, key)) || desc.enumerable });
  }
  return target;
};
var __toModule = (module2) => {
  return __reExport(__markAsModule(__defProp(module2 != null ? __create(__getProtoOf(module2)) : {}, "default", module2 && module2.__esModule && "default" in module2 ? { get: () => module2.default, enumerable: true } : { value: module2, enumerable: true })), module2);
};
__export(exports, {
  appendUserData: () => appendUserData,
  cleanUserData: () => cleanUserData,
  cloneDeep: () => cloneDeep,
  extractUserData: () => extractUserData,
  getFieldValidationMessage: () => getFieldValidationMessage,
  getValueDefault: () => getValueDefault,
  getValueValidationMessage: () => getValueValidationMessage,
  isValueLegal: () => isValueLegal,
  isValueValid: () => isValueValid,
  mergeUserData: () => mergeUserData,
  removeDuplicates: () => removeDuplicates,
  splitWhenEmpty: () => splitWhenEmpty,
  translateUserData: () => translateUserData,
  validateUserData: () => validateUserData
});
var import_papaya = __toModule(require("@taxdown/papaya"));
var import_invalidType = __toModule(require("./error/invalidType"));
var import_errorMessages = __toModule(require("./errorMessages"));
const getRef = (validationType) => {
  return import_papaya.default.model.TYPES[validationType];
};
const appendUserData = (userData, addData) => {
  if (Object.keys(userData).length === 0) {
    return cloneDeep(addData);
  } else if (Object.keys(addData).length === 0) {
    return cloneDeep(userData);
  }
  return Object.keys(userData).reduce((acc, key) => {
    acc[key] = userData[key].concat(addData[key]);
    return acc;
  }, {});
};
const removeDuplicates = (array) => {
  const seen = new Set();
  return array.filter((item) => {
    const isDuplicate = seen.has(JSON.stringify(item));
    if (!isDuplicate) {
      seen.add(JSON.stringify(item));
    }
    return !isDuplicate;
  });
};
const cloneDeep = (value) => {
  return JSON.parse(JSON.stringify(value));
};
const cleanUserData = (userData, dictionary) => {
  const userDataCopy = cloneDeep(userData);
  dictionary.forEach((key) => {
    delete userDataCopy[key];
  });
  return userDataCopy;
};
const extractUserData = (userData, dictionary) => {
  return dictionary.reduce((acc, key) => {
    if (userData[key]) {
      acc[key] = userData[key];
    }
    return acc;
  }, {});
};
const splitWhenEmpty = (userData, dictionaryKeys, key) => {
  var _a;
  const empty = {};
  const filled = {};
  const userValue = (_a = userData[key]) != null ? _a : [];
  for (const [i, value] of userValue.entries()) {
    const isEmpty = value === "";
    for (const key2 of dictionaryKeys) {
      if (isEmpty) {
        empty[key2] = Array.isArray(empty[key2]) ? empty[key2] : [];
        empty[key2].push(userData[key2][i]);
      } else {
        filled[key2] = Array.isArray(filled[key2]) ? filled[key2] : [];
        filled[key2].push(userData[key2][i]);
      }
    }
  }
  return { empty, filled };
};
const mergeUserData = (userData, dictionary, mergeKeys) => {
  var _a;
  const userDataLength = (_a = userData[mergeKeys[0]]) == null ? void 0 : _a.length;
  if (!userDataLength) {
    return {};
  }
  const result = {};
  const skipIndexes = [];
  for (let i = 0; i < userDataLength; i += 1) {
    if (skipIndexes.includes(i)) {
      continue;
    }
    Object.keys(userData).forEach((key) => {
      result[key] = Array.isArray(result[key]) ? result[key] : [];
      result[key].push(userData[key][i]);
    });
    for (let j = i + 1; j < userDataLength; j += 1) {
      let matchCount = 0;
      for (const key of mergeKeys) {
        if (userData[key][i] === userData[key][j]) {
          matchCount += 1;
        }
      }
      if (matchCount === mergeKeys.length) {
        skipIndexes.push(j);
        Object.keys(userData).forEach((key) => {
          if (dictionary[key].default === 0) {
            result[key][i] = result[key][i] + userData[key][j];
          } else if (dictionary[key].default === "") {
            result[key][i] = result[key][i] || userData[key][j];
          } else if (dictionary[key].default === null) {
          } else {
            throw new Error(`Unknown type ${dictionary[key].default}`);
          }
        });
      }
    }
  }
  return result;
};
const translateUserData = (userData, inputDictionary, outputDictionary) => {
  var _a;
  if (Object.keys(userData).length === 0) {
    return {};
  }
  const translation = Object.keys(outputDictionary).map((key) => {
    const match = Object.keys(inputDictionary).find((inputKey) => {
      return outputDictionary[key].name === inputDictionary[inputKey].name;
    });
    return __spreadProps(__spreadValues({}, inputDictionary[match]), { newKey: key, newDefault: outputDictionary[key].default });
  });
  const userDataLength = (_a = userData[translation[0].id]) == null ? void 0 : _a.length;
  const result = translation.reduce((acc, item) => {
    const newValue = userData[item.id] || new Array(userDataLength).fill(item.newDefault);
    return __spreadProps(__spreadValues({}, acc), { [item.newKey]: newValue });
  }, {});
  return result;
};
const getArrayLength = (value) => {
  return (value == null ? void 0 : value.length) || 0;
};
const validateUserData = (userData, dictionary) => {
  const length = getArrayLength(userData[dictionary[0]]);
  for (const key of dictionary) {
    if (getArrayLength(userData[key]) !== length) {
      return false;
    }
  }
  return true;
};
const isValueLegal = (value, validationType, validations) => {
  const model = import_papaya.default.model.TYPES[validationType];
  if (!model) {
    throw new import_invalidType.InvalidType(validationType);
  }
  return model.sanitize(value, validations) === value;
};
const isValueValid = (value, validationType, validations) => {
  const model = import_papaya.default.model.TYPES[validationType];
  if (!model) {
    throw new import_invalidType.InvalidType(validationType);
  }
  return model.validate(value, validations);
};
const getValueDefault = (validationType) => {
  const model = import_papaya.default.model.TYPES[validationType];
  if (!model) {
    throw new import_invalidType.InvalidType(validationType);
  }
  return model.getDefaultValue();
};
const getValueValidationMessage = (_value, validationType) => {
  const model = import_papaya.default.model.TYPES[validationType];
  if (!model) {
    throw new import_invalidType.InvalidType(validationType);
  }
  return model.message(void 0, void 0, false);
};
const getFieldValidationMessage = (value, validationType, validations) => {
  if (!isValueValid(value, validationType, validations)) {
    const validRef = getRef(validationType);
    const message = import_errorMessages.ERROR_MESSAGE[validRef.message(value, validations, false)];
    return message.replace(/{{([a-z]+)}}/, (_match, p1) => {
      const validateValue = validations[p1.replace(/[{}]/g)];
      if (validationType === "Date" && validateValue.length === 8) {
        return validateValue.substring(0, 2) + "/" + validateValue.substring(2, 4) + "/" + validateValue.substring(4, 8);
      }
      return validateValue;
    });
  }
};
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  appendUserData,
  cleanUserData,
  cloneDeep,
  extractUserData,
  getFieldValidationMessage,
  getValueDefault,
  getValueValidationMessage,
  isValueLegal,
  isValueValid,
  mergeUserData,
  removeDuplicates,
  splitWhenEmpty,
  translateUserData,
  validateUserData
});
